export function useViewport() {
  const { $viewport } = useNuxtApp()

  // Add safety checks to prevent errors during SSR or before plugin initialization
  if (!$viewport || !$viewport.w) {
    // Return default values during SSR or initialization
    const fallbackWidth = ref(1280)
    const fallbackHeight = ref(720)
    
    return {
      w: fallbackWidth,
      h: fallbackHeight,
      ww: fallbackWidth,
      wh: fallbackHeight,
      activeDeviceMedia: computed(() => 'desktop'),
      isMobile: computed(() => false),
      isTabletOrMobile: computed(() => false),
      isTabletOrGreater: computed(() => true),
      isTablet: computed(() => false),
      isDesktop: computed(() => true),
    }
  }

  const isMobile  = computed(() => $viewport.w.value <  550)
  const isTabletOrMobile = computed(() => $viewport.w.value < 1200)
  const isTablet  = computed(() => $viewport.w.value >= 550 && $viewport.w.value < 1280)
  const isTabletOrGreater = computed(() => $viewport.w.value > 550)
  const isDesktop = computed(() => $viewport.w.value >= 1280)
  const activeDeviceMedia = computed(() => isTabletOrMobile.value ? 'mobile' : 'desktop')

  return {
    ...$viewport, // w, h (Refs)
    
    activeDeviceMedia,
    ww: $viewport.w,
    wh: $viewport.h,
    isMobile,
    isTabletOrMobile,
    isTabletOrGreater,
    isTablet,
    isDesktop,
  }
}